import * as moment from 'moment-timezone';
import * as momentFormat from 'moment';
import { isDate } from 'lodash';

export function getUserNamesFromString(userObjString: string): string {

  let userNames = '';
  if (!!userObjString) {
    let users = JSON.parse(userObjString);

    users.forEach((user) => {
      if (userNames === '') {
        userNames = user.displayName;
      } else {
        userNames = ',' + user.displayName;
      }
    });
  }

  return userNames;
}

export function getUsersNamesFromUsersString(userObjString: string): string {
  let userNames = '';
  if (!!userObjString) {
    let users = JSON.parse(userObjString);
    userNames = users.map((x) => x.displayName).join(',');
    return userNames;
  }
  return userNames;
}

export function getUsersEmailsFromUsersString(userObjString: string): string {
  let userNames = '';
  if (!!userObjString) {
    let users = JSON.parse(userObjString);
    userNames = users.map((x) => x.mail).join(';');
    return userNames;
  }
  return userNames;
}

export function formatDate(dateObj) {
  const today = new Date(dateObj);
  const year = today.getFullYear().toString();
  const month = today.toLocaleString('default', { month: 'short' });
  const date = ('0' + today.getDate().toString()).slice(-2);
  const joinmonth = [date, month].join(' ');
  return [joinmonth, year].join(' ');
}

export function splitandJoinMdate(obj) {
  let formattedDate = obj.split(';').map((value) => {
    return formatDate(value + 'T00:00:00');
  });
  let dateString = formattedDate.join('; ');
  return dateString;
}

export function GetDateFromDateObject(val) {
  if (val !== undefined && val != null && isDate(val)) {
    var date = new Date(val);
    const sDateStrng = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
    return sDateStrng;
  }
  return val;
}

export function formatDateTimeToUTC(val) {
  if (val !== undefined && val != null && isDate(val)) {
    const utcTime = moment.utc(val).format();
    return utcTime;
  }
  return val;
}

export function formatDateTimeToDatestring(val) {
  if (!val) return val;
  const date = isDate(val) ? moment(val) : moment(val, moment.ISO_8601, true);
  if (!date.isValid()) return val;
  return date.format("YYYY-MM-DD");
}


export function formatPacifictoLocal(pacificDateObj) {
    let localDate =  moment.tz(pacificDateObj, 'America/Los_Angeles').local().format();
    return new Date(localDate);
}

export function normalizeDateToLocal(dateStr) {
    if (!dateStr) return null;

    // If ISO date string with time, keep only the date part
    if (dateStr.includes("T")) {
      dateStr = dateStr.split("T")[0];
    }

    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
    if (match) {
      const [_, y, m, d] = match.map(Number);
      // Use Date(year, monthIndex, day) — monthIndex is 0-based
      return new Date(y, m - 1, d);
    }

    const parsed = new Date(dateStr);
    return isNaN(parsed.getTime()) ? null : parsed;
  
  // if (!dateStr) return null;
  // if (dateStr.includes("T")) {
  //   dateStr = dateStr.split("T")[0];
  // }
  // const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
  // if (match) {
  //   const [_, y, m, d] = match.map(Number);
  //   const localDate = new Date(0);
  //   localDate.setFullYear(y);
  //   localDate.setMonth(m - 1);
  //   localDate.setDate(d);
  //   localDate.setHours(0, 0, 0, 0);
  //   return localDate;
  // }
  // const parsed = new Date(dateStr);
  // return isNaN(parsed.getTime()) ? null : parsed;
}


export function setDateFieldsToUTC(value: any) {
  Object.keys(value).forEach((field) => {
    let val = value[field];
    if (val !== null && isDate(val)) {
      if (
        field === "OtherTASTeamMembersSignOffDate" ||
        field === "TAS2ndExecSignOffDate" ||
        field === "TASAuditAssistExecSignOffDate" ||
        field === "TASAuditAssistLeaderSignOffDate" ||
        field === "TASAuditAssistManagerSignOffDate"
      ) {
        value[field] = formatDateTimeToUTC(val);
      } else {
        value[field] = formatDateTimeToDatestring(val);
      }      
    }
  });
}

export function formatDDMMYYY(val){
  return moment(val).format("DD MMMM YYYY");
}


export function formatLocalToPacific(val) {
  if (val !== undefined && val != null && isDate(val)) {
    var date = new Date(val);
    const sDateStrng2 = moment(new Date().toISOString()).tz('America/Los_Angeles').format()//US pacific time
    return sDateStrng2;
  }
  return val;
}
